export enum ReferralProgramsError {
  PARTICIPANT_NOT_FOUND = "PARTICIPANT_NOT_FOUND",
}
